module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "name": "hrms12x-detail-notsend",
      "id": "hrms12x-detail-notsend"
    }
  }, [_c('div', {
    staticClass: "modal-header header-popup"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.labels['HRMS12X']['140']))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body detail detail-responsive"
  }, [_c('div', {
    staticClass: "detail detail-responsive"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "col-md-2 panel-left"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label"
  }, [_vm._v(_vm._s(_vm.labels['HRMS12X']['160']))]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "input",
      "readonly": "readonly"
    },
    domProps: {
      "value": _vm.data.rows[0].sender_id + ' - ' + _vm.data.rows[0].sender_name
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label"
  }, [_vm._v(_vm._s(_vm.labels['HRMS12X']['170']))]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "input",
      "readonly": "readonly"
    },
    domProps: {
      "value": _vm.data.rows[0].sender_email
    }
  })])])]), _vm._v(" "), _c('hrms-table', {
    attrs: {
      "columns": _vm.columns,
      "data": _vm.data,
      "searchDisp": true
    }
  })], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5ca7a40a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hrms12x/detailNotSend.vue
// module id = 3801
// module chunks = 1